import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountComponent } from './account.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { LoginComponent } from './login/login.component';
import { AuthGuardService } from '../guards/auth-guard.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ConfirmEmailComponent } from './confirm-email/confirm-email.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RegisterSuccessComponent } from './register-success/register-success.component';
import { RegistrationGuardService } from '../guards/register-guard.service';

const routes: Routes = [
	{
		path: '',
		component: AccountComponent,
		children: [
			{ path: '', pathMatch: 'full', redirectTo: 'login' },
			{
				path: 'unauthorized',
				component: UnauthorizedComponent,
				canActivate: [ AuthGuardService ]
			},
			{ path: 'login', component: LoginComponent },
			{
				path: 'registration-success',
				component: RegisterSuccessComponent,
				canActivate: [ RegistrationGuardService ]
			},
			{ path: 'forgot-password', component: ForgotPasswordComponent },
			{ path: 'account/reset-password', component: ResetPasswordComponent },
			{ path: 'account/confirm-email', component: ConfirmEmailComponent }
		]
	}
];

@NgModule({
	imports: [ RouterModule.forChild(routes) ],
	exports: [ RouterModule ],
	declarations: []
})
export class AccountRoutingModule {}
